/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { NavLink,useLocation } from "react-router-dom";
// import SVG from "react-inlinesvg";
// import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { checkIsActive } from "../../../../_helpers";
import { Receipt, ShieldCheck, LayoutTextWindowReverse, Search, QuestionCircle, ClipboardData, Files } from "react-bootstrap-icons";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} /> */}
              <LayoutTextWindowReverse/>
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Receipt Tracking */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/receipt-tracking", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/receipt-tracking">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} /> */}
              <Search/>
            </span>
            <span className="menu-text">Receipt Tracking</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Log Maintenance */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/log-maintenance", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/log-maintenance">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Clipboard.svg")} />
            </span>
            <span className="menu-text">Log Maintenance</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}

        {/* Reporting */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/reporting", true)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/reporting">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Chart-line1.svg")} /> */}
              <ClipboardData/>
            </span>
            <span className="menu-text">Report Management</span>
          </NavLink>
          <div className="menu-submenu ">
            <ul className="menu-subnav">
              <li
                  className={`menu-item ${getMenuItemActive("/reporting/end-of-day-report")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/reporting/end-of-day-report">
                    <span className="svg-icon menu-icon">
                      <Files/>
                    </span>
                    <span className="menu-text">EOD Report</span>
                  </NavLink>
                </li>
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}


        {/* Dispute Resolution */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dispute-resolution", true)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dispute-resolution/generate-receipt">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Chart-line1.svg")} /> */}
              <ShieldCheck/>
            </span>
            <span className="menu-text">Dispute Resolution</span>
          </NavLink>
          <div className="menu-submenu ">
            <ul className="menu-subnav">
              <li
                  className={`menu-item ${getMenuItemActive("/dispute-resolution/generate-receipt")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/dispute-resolution/generate-receipt">
                    <span className="svg-icon menu-icon">
                      <Receipt/>
                    </span>
                    <span className="menu-text">Generate E-Receipt</span>
                  </NavLink>
                </li>
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}



        {/* Refund Management */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/refund-management", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/refund-management">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Text/Undo.svg")} />
            </span>
            <span className="menu-text">Refund Management</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}

        {/* Administration */}
        {/* begin::section */}
        {/* <li className="menu-section ">
          <h4 className="menu-text">Administration</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li> */}
        {/* end:: section */}

        {/* User Management */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/administration/user-management",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
          aria-expanded="true"
        > */}
          {/* <NavLink className="menu-link menu-toggle" to="/administration/user-management">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
            </span>
            <span className="menu-text">User Management</span>
            <i className="menu-arrow" />
          </NavLink> */}
          {/* <div className="menu-submenu ">
            <ul className="menu-subnav">
              <ul className="menu-subnav"> */}
                {/* <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span className="menu-text">User Management</span>
                  </span>
                </li> */}

                {/*begin::2 Level*/}
                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/administration/user-management/manage-user"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/administration/user-management/manage-user">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Manage Users</span>
                  </NavLink>
                </li> */}
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/administration/user-management/manage-role"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/administration/user-management/manage-role">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Manage Roles</span>
                  </NavLink>
                </li> */}
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/administration/user-management/manage-group"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/administration/user-management/manage-group"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Manage Groups</span>
                  </NavLink>
                </li> */}
                {/*end::2 Level*/}

              {/* </ul>
            </ul>
          </div>
        </li> */}
        {/*end::1 Level*/}   

        {/* Agency Management */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/administration/agency-management", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/administration/agency-management">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Building.svg")} />
            </span>
            <span className="menu-text">Agency Management</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}

        {/* Reference Management */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/administration/ref-info-management", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/administration/ref-info-management">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Binocular.svg")} />
            </span>
            <span className="menu-text">Reference Management</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}

        {/* BSP Reconciliation */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/bsp-reconciliation", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/bsp-reconciliation">
            <span className="svg-icon menu-icon">
              <Files/>
            </span>
            <span className="menu-text">BSP Reconciliation</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}  

        {/* Help*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/help", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/help">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Question-circle.svg")} /> */}
              <QuestionCircle/>
            </span>
            <span className="menu-text">Help</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}          

      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
